/* LOGIXA homepage content — MD (română). Shape must match de.ts exactly. */

export const md = {
  nav: {
    links: [
      { label: 'Produs', href: '#plattform' },
      { label: 'Soluții', href: '#disposition' },
      { label: 'Integrări', href: '#integrationen' },
      { label: 'Prețuri', href: '#preise' },
      { label: 'Resurse', href: '/docs' },
    ],
    login: 'Autentificare',
    demo: 'Programează demo',
    menu: 'Meniu',
  },

  hero: {
    kicker: 'TRANSPORT MANAGEMENT SYSTEM',
    h1: 'Software TMS pentru transportatorii cărora nu le ajunge doar dispecerizarea.',
    sub: 'Comenzi, dispecerizare, șoferi, parc auto, GPS, documente și facturare într-o singură platformă. LOGIXA leagă întreaga organizație de transport — de la comandă la factură.',
    primary: 'Programează demo',
    secondary: 'Vezi demo live',
    trust: ['Conform GDPR', 'Găzduire în Germania', '9 limbi', 'Lansare în 12 zile'],
    demoNote: 'Date demonstrative',
  },

  mock: {
    search: 'Caută…',
    user: 'Max Mustermann',
    role: 'ADMIN',
    nav: ['Prezentare', 'Comenzi', 'Dispecerizare', 'Vehicule', 'Șoferi', 'Planificare curse', 'Urmărire GPS', 'Documente', 'Mesaje', 'Rapoarte', 'Facturare', 'Setări'],
    live: 'LIVE',
    card: {
      id: 'FLEET-DEMO-118',
      route: 'Hamburg, DE → Rotterdam, NL',
      etaLbl: 'ETA',
      eta: 'Astăzi, 14:30',
      driverLbl: 'ȘOFER',
      driver: 'John D.',
      progress: 64,
    },
    ordersTitle: 'Comenzi active',
    orders: [
      { id: 'FLEET-DEMO-118', state: 'ÎN CURSĂ', tone: 'go' },
      { id: 'FLEET-DEMO-117', state: 'ÎN CURSĂ', tone: 'go' },
      { id: 'FLEET-DEMO-116', state: 'ÎNCĂRCARE', tone: 'load' },
      { id: 'FLEET-DEMO-115', state: 'PLANIFICAT', tone: 'plan' },
      { id: 'FLEET-DEMO-114', state: 'FINALIZAT', tone: 'done' },
    ],
    kpiTitle: 'KPI astăzi',
    kpis: [
      { lbl: 'COMENZI', val: '850', delta: '+14 %' },
      { lbl: 'CURSE GOALE', val: '14 %', delta: '−16 %' },
      { lbl: 'VENIT', val: '€92K', delta: '+18 %' },
    ],
    statusTitle: 'Starea vehiculelor',
    status: [
      { n: '104', lbl: 'ÎN CURSĂ' },
      { n: '18', lbl: 'ÎNCĂRCARE' },
      { n: '7', lbl: 'DESCĂRCARE' },
      { n: '4', lbl: 'SERVICE' },
      { n: '2', lbl: 'INACTIVE' },
    ],
    plates: [
      { p: 'HH-LOG 33', tone: 'go' },
      { p: 'B-KT 155', tone: 'acc' },
      { p: 'K-AB 147', tone: 'idle' },
    ],
  },

  integrations: {
    label: 'Integrare în infrastructura\nlogistică existentă',
    items: ['TIMOCOM', 'Trans.eu', 'DATEV', 'Stripe', 'SEPA', 'n8n', 'Make', 'Zapier'],
  },

  platform: {
    kicker: 'PLATFORMĂ',
    h2: 'Firma dumneavoastră. Un singur sistem.',
    sub: 'Fără tabele Excel. Fără sisteme separate pentru șoferi, GPS și facturare. Fără căutarea informației în cinci instrumente.',
    areas: [
      {
        n: '01',
        title: 'Comenzi și dispecerizare',
        desc: 'Înregistrați comenzi, alocați șoferi și vehicule, planificați curse și urmăriți starea transportului în timp real.',
        chips: ['Comenzi', 'Dispecerizare AI', 'Planificare curse', 'ePOD'],
      },
      {
        n: '02',
        title: 'Parc auto și GPS',
        desc: 'Urmăriți vehiculele live, planificați mentenanța, monitorizați TCO și gestionați geofence-urile.',
        chips: ['Live GPS', 'TCO', 'Mentenanță', 'Geofencing'],
      },
      {
        n: '03',
        title: 'Șoferi și conformitate',
        desc: 'Timpul de lucru, documentele, tahograful și regulile EU 561 într-un singur loc — înainte ca termenele să devină o problemă.',
        chips: ['Tahograf', 'EU 561', 'ADR', 'Modul 95'],
      },
      {
        n: '04',
        title: 'Salarizare și finanțe',
        desc: 'Salarii, sporuri, plăți și procese DATEV conectate direct cu datele operaționale de transport.',
        chips: ['Payroll', 'DATEV', 'SEPA', 'Stripe'],
      },
    ],
    cta: 'Vezi toate funcțiile',
  },

  dispatch: {
    kicker: 'DISPECERIZARE INTELIGENTĂ',
    h2: 'Dispecerizare care gândește.',
    sub: 'LOGIXA ia în calcul șoferii, vehiculele, timpii de conducere, disponibilitatea și ruta și susține dispecerul în alocarea optimă.',
    points: [
      { title: 'Dispecerizare AI', desc: 'Propune șoferul și vehiculul potrivite pentru comandă.' },
      { title: 'Optimizarea rutei', desc: 'Ia în calcul taxele de drum, distanța, timpii de conducere și combustibilul.' },
      { title: 'Diesel Intelligence', desc: 'Planifică alimentările după prețurile actuale ale carburantului de-a lungul rutei.' },
    ],
    panelTitle: 'Recomandare de rută',
    metrics: [
      { lbl: 'Distanță', val: '1.346 km' },
      { lbl: 'Timp de condus', val: '17 h 25 min' },
      { lbl: 'Taxe de drum', val: '€ 128,40' },
      { lbl: 'CO₂', val: '1.245 kg' },
    ],
    stopsTitle: 'Alimentări recomandate',
    live: 'LIVE',
    stops: [
      { city: 'Hannover', price: '€ 1,59', best: false },
      { city: 'Kassel', price: '€ 1,58', best: false },
      { city: 'Frankfurt', price: '€ 1,55', best: true },
      { city: 'Würzburg', price: '€ 1,62', best: false },
    ],
    apply: 'Preia ruta',
    source: 'Surse de prețuri: Tankerkönig (DE), prix-carburants (FR), E-Control (AT), MITECO (ES)',
  },

  driver: {
    kicker: 'APLICAȚIA ȘOFERULUI',
    h2: 'Șoferul are totul la el.',
    sub: 'Aplicații native pentru iOS și Android — întregul flux al cursei, de la comandă la semnătură, inclusiv fără semnal.',
    flow: ['Primire comandă', 'Pornire navigație', 'Scanare documente', 'Semnare ePOD', 'Închidere cursă'],
    chips: ['iOS', 'Android', 'Mod offline', 'Bot Telegram', '9 limbi'],
    phones: [
      {
        tag: 'COMANDA #DE-1107',
        title: 'Hamburg → Rotterdam',
        rows: [
          { lbl: 'ÎNCĂRCARE', val: 'Astăzi 08:30' },
          { lbl: 'LIVRARE', val: 'Astăzi 14:30' },
          { lbl: 'VEHICUL', val: 'HH-LOG 33' },
          { lbl: 'MARFĂ', val: '18 paleți · 12,4 t' },
        ],
        action: 'Pornire navigație',
      },
      {
        tag: 'DOCUMENTE',
        title: 'Scanare CMR',
        rows: [
          { lbl: 'SCRISOARE DE TRĂSURĂ', val: 'CMR-2026-4471' },
          { lbl: 'STARE', val: 'Scanat · 2 pagini' },
          { lbl: 'AVIZ DE LIVRARE', val: 'În așteptare' },
        ],
        action: 'Încarcă scanarea',
      },
      {
        tag: 'ePOD',
        title: 'Confirmă recepția',
        rows: [
          { lbl: 'DESTINATAR', val: 'De Vries Logistics BV' },
          { lbl: 'SEMNĂTURĂ', val: 'Înregistrată' },
          { lbl: 'FOTO', val: '3 atașamente' },
        ],
        action: 'Închide cursa',
      },
    ],
  },

  compliance: {
    kicker: 'CONFORMITATE ȘI SECURITATE',
    h2: 'Vedeți timpii de conducere înainte să devină o problemă.',
    sub: 'Timpii de conducere și odihnă, datele de tahograf și documentele care expiră într-un singur loc — cu avertizare cât timp mai este loc de reacție.',
    points: [
      { title: 'EU 561', desc: 'Timpii actuali de conducere și odihnă pentru fiecare șofer, verificați continuu.' },
      { title: 'Tahograf', desc: 'Import fișiere DDD și control asupra datelor șoferului.' },
      { title: 'Documente', desc: 'Avertizări înainte de expirarea permisului, ADR și Modul 95.' },
    ],
    dashDriverLbl: 'Șofer',
    dashDriver: 'John D.',
    badge: 'CONFORM',
    bars: [
      { lbl: 'Condus astăzi', val: '7 h 45 / 9 h', pct: 86, tone: 'warn' },
      { lbl: 'Condus săptămânal', val: '38 h 10 / 56 h', pct: 68, tone: 'ok' },
      { lbl: 'Următoarea odihnă', val: 'în 1 h 15 min', pct: 42, tone: 'ok' },
    ],
    docsTitle: 'Documente care expiră',
    docs: [
      { lbl: 'Permis de conducere', val: '12.03.2027', warn: false },
      { lbl: 'Certificat ADR', val: '18.05.2027', warn: true },
      { lbl: 'Modul 95', val: '22.09.2027', warn: false },
    ],
    alerts: '3 AVERTIZĂRI ACTIVE',
  },

  onboarding: {
    kicker: 'TRANZIȚIE',
    h2: 'Tot pe Excel? Nicio problemă.',
    sub: 'Preluăm șoferii, vehiculele și partenerii de afaceri din Excel, CSV sau din TMS-ul actual.',
    promoTitle: 'Gata de lucru în 12 zile.',
    promoSub: 'Rapid. Sigur. Fără risc.',
    promoCta: 'Programează demo',
    steps: [
      { tag: 'ZIUA 1', title: 'Analiza proceselor', desc: 'Demo și analiza fluxurilor dumneavoastră.' },
      { tag: 'ZILELE 2–4', title: 'Start pilot', desc: 'Operare pilot cu vehicule reale.' },
      { tag: 'ZILELE 5–8', title: 'Import de date', desc: 'Preluarea șoferilor, vehiculelor și nomenclatoarelor.' },
      { tag: 'ZILELE 9–10', title: 'Instruirea echipei', desc: 'Instruirea dispecerilor și a șoferilor.' },
      { tag: 'ZILELE 11–12', title: 'Lansare', desc: 'Start în producție cu suport complet.' },
    ],
  },

  roi: {
    kicker: 'POTENȚIAL DE ECONOMIE',
    h2: 'Ce schimbă LOGIXA în parcul dumneavoastră.',
    fields: [
      { lbl: 'Vehicule', unit: '' },
      { lbl: 'Șoferi', unit: '' },
      { lbl: 'Comenzi pe lună', unit: '' },
      { lbl: 'Km medii pe vehicul și an', unit: 'km' },
    ],
    panelTitle: 'POTENȚIAL PE AN',
    lines: ['Mai puțină muncă administrativă', 'Curse goale optimizate', 'Optimizarea combustibilului'],
    totalLbl: 'Potențial estimat',
    basisLink: 'Arată baza de calcul',
    basisClose: 'Ascunde baza de calcul',
    basis: [
      'Administrare: 7,50 € per comandă (circa 13 minute la un cost de personal de 34 €/h) plus 15 € per șofer și lună pentru pontaj și pregătirea salariilor.',
      'Curse goale: 18 % pondere a kilometrilor în gol, dintre care 5 % evitabili printr-o dispecerizare mai bună, la un cost de 1,04 € pe kilometru.',
      'Combustibil: consum de 30 l la 100 km și o economie de 2 cenți pe litru prin planificarea alimentărilor de-a lungul rutei — pe baza prețurilor live de la Tankerkönig (DE), prix-carburants (FR), E-Control (AT) și MITECO (ES).',
      'Toate valorile sunt o estimare bazată pe ipoteze uzuale din industrie și nu o economie garantată.',
    ],
  },

  pricing: {
    kicker: 'PREȚURI',
    h2: 'Prețuri transparente. Predictibile. Corecte.',
    sub: 'Alegeți planul potrivit parcului dumneavoastră. Reziliere lunară.',
    allLink: 'Vezi toate prețurile',
    perMonth: '/ lună',
    badge: 'RECOMANDAT',
    cta: 'Programează demo',
    plans: [
      {
        name: 'STARTER', price: '€199', custom: false, scope: 'până la 15 vehicule',
        features: ['Management comenzi', 'Aplicația șoferului', 'Urmărire GPS', 'Suport e-mail'],
      },
      {
        name: 'BUSINESS', price: '€499', custom: false, scope: 'până la 50 vehicule',
        features: ['Toate funcțiile Starter', 'Dispecerizare AI', 'Tahograf și EU 561', 'Suport prioritar'],
      },
      {
        name: 'ENTERPRISE', price: 'Individual', custom: true, scope: 'peste 50 vehicule',
        features: ['Toate funcțiile Business', 'Drepturi extinse', 'API și integrări', 'Persoană de contact dedicată'],
      },
    ],
    note: ['Parcurile mici încep mai ieftin: ', 'BASIC de la 49 €/lună', ' pentru până la 3 vehicule, ', 'DRIVER gratuit', ' pentru transportatorii independenți cu un singur camion.'],
  },

  security: {
    title: 'Datele dumneavoastră rămân în Europa.',
    items: ['Găzduire în Germania', 'Conform GDPR', '2FA și Passkeys', 'Jurnale de audit', 'Criptare la stocare'],
  },

  faq: {
    kicker: 'FAQ',
    h2: 'Întrebări frecvente despre software-ul TMS.',
    sub: 'Au rămas întrebări? Le răspundem în demo.',
    list: [
      {
        q: 'Ce este un software TMS?',
        a: 'Un Transport Management System reunește procesarea comenzilor, dispecerizarea, gestiunea vehiculelor și a șoferilor, documentele și facturarea într-o singură platformă — în locul tabelelor Excel separate, portalurilor GPS și programelor de contabilitate.',
      },
      {
        q: 'Pentru ce transportatori este potrivită LOGIXA?',
        a: 'Pentru firme de transport și case de expediții de la 3 până la peste 50 de vehicule. Transportatorii independenți cu un camion pornesc pe planul gratuit DRIVER, parcurile mici pe BASIC de la 49 €/lună, firmele medii pe STARTER sau BUSINESS.',
      },
      {
        q: 'Poate LOGIXA înlocui Excel?',
        a: 'Da. Comenzile, șoferii, vehiculele, nomenclatoarele și facturarea stau într-o singură bază de date, nu în tabele împrăștiate. Fișierele Excel și CSV existente le preluăm la tranziție — porniți cu propriile date.',
      },
      {
        q: 'Cât durează implementarea?',
        a: 'Planificăm tranziția în 12 zile: analiza proceselor, operare pilot cu vehicule reale, import de date, instruire și lansare. Acest calendar este metoda noastră de lucru, nu o medie măsurată pe proiecte de client.',
      },
      {
        q: 'Pot păstra GPS-ul actual?',
        a: 'În multe cazuri da. LOGIXA preia pozițiile prin aplicația șoferului fără hardware suplimentar și poate, în paralel, prelua date telematice din sistemele existente. Ce conexiune este posibilă în cazul dumneavoastră stabilim înainte de start.',
      },
      {
        q: 'Susține LOGIXA tahograful și EU 561?',
        a: 'Timpii de conducere și odihnă conform EU 561 sunt evaluați continuu pentru fiecare șofer, inclusiv avertizări înainte de depășire. Fișierele DDD din tahograf pot fi importate și consultate; evaluarea nu este destinată ca interpretare oficială a tahografului pentru autorități.',
      },
      {
        q: 'Există o aplicație pentru șofer?',
        a: 'Da, aplicații native pentru iOS și Android în nouă limbi: comandă, navigație, scanare documente, semnătură ePOD și închiderea cursei — inclusiv offline. În plus există un bot Telegram pentru șoferii fără aplicație instalată.',
      },
      {
        q: 'Se poate conecta LOGIXA cu TIMOCOM și Trans.eu?',
        a: 'Conectorii sunt pregătiți și scriși după interfețele documentate. Activarea se face prin propriul dumneavoastră contract TIMOCOM sau Trans.eu; la implementare configurăm conexiunea împreună și o testăm cu datele dumneavoastră de acces.',
      },
      {
        q: 'Unde sunt stocate datele?',
        a: 'Pe servere în Germania, conform GDPR, criptate în tranzit și la stocare. Accesările sunt jurnalizate, autentificarea poate fi protejată cu 2FA și Passkeys.',
      },
      {
        q: 'Cât costă LOGIXA?',
        a: 'DRIVER este gratuit pentru transportatorii independenți cu un camion, BASIC pornește de la 49 €/lună pentru până la 3 vehicule, STARTER costă 199 €/lună până la 15 vehicule, BUSINESS 499 €/lună până la 50 vehicule. Peste 50 de vehicule calculăm individual. Toate planurile se pot rezilia lunar.',
      },
    ],
  },

  finalCta: {
    h2: 'Vedeți LOGIXA pe propriile procese de transport.',
    sub: 'Într-un demo de 30 de minute vă arătăm exact modulele relevante pentru parcul dumneavoastră.',
    primary: 'Programează demo',
    secondary: 'Vezi demo live',
  },

  footer: {
    tagline: 'Software TMS pentru firme de transport și case de expediții din Europa.',
    cols: [
      {
        title: 'PRODUS',
        links: [
          { label: 'Funcții', href: '/platform/funktionen' },
          { label: 'Dispecerizare AI', href: '/platform/ki' },
          { label: 'Aplicația șoferului', href: '/platform/funktionen#apps' },
          { label: 'Planificare curse', href: '/platform/funktionen#tourenplanung' },
          { label: 'Facturare', href: '/platform/backoffice' },
        ],
      },
      {
        title: 'SOLUȚII',
        links: [
          { label: 'Transportatori mici', href: '/pricing' },
          { label: 'Parcuri medii', href: '/pricing' },
          { label: 'Transport internațional', href: '/platform/funktionen' },
          { label: 'Șoferi independenți', href: '/pricing' },
        ],
      },
      {
        title: 'INTEGRĂRI',
        links: [
          { label: 'TIMOCOM', href: '/platform/integrationen' },
          { label: 'Trans.eu', href: '/platform/integrationen' },
          { label: 'DATEV', href: '/platform/integrationen' },
          { label: 'Telegram', href: '/platform/integrationen' },
          { label: 'Toate integrările', href: '/platform/integrationen' },
        ],
      },
      {
        title: 'RESURSE',
        links: [
          { label: 'Bază de cunoștințe', href: '/docs' },
          { label: 'Blog', href: '/blog' },
          { label: 'Ce este un TMS?', href: '/docs' },
          { label: 'Costurile unui TMS', href: '/pricing' },
          { label: 'Centru de ajutor', href: '/docs' },
        ],
      },
      {
        title: 'COMPANIE',
        links: [
          { label: 'Despre noi', href: '/about' },
          { label: 'Cariere', href: '/jobs' },
          { label: 'Parteneri', href: '/companies' },
          { label: 'Contact', href: '/kontakt' },
        ],
      },
    ],
    copyright: '© 2026 LOGIXA. Toate drepturile rezervate.',
    legal: [
      { label: 'Confidențialitate', href: '/datenschutz' },
      { label: 'Impressum', href: '/impressum' },
      { label: 'Termeni', href: '/agb' },
      { label: 'Securitate', href: '/platform/funktionen#sicherheit' },
    ],
  },
};
